import React from 'react';

type SirenRneContextType = {
    currentSousClient: { siren?: string } | undefined;
    dossier: { societeSiren?: string; clientOpereSiren?: string } | undefined;
};

export const SirenRneContext = React.createContext<SirenRneContextType>({
    currentSousClient: undefined,
    dossier: undefined,
});

export const useSirenRneContext = () => React.useContext(SirenRneContext);
